// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3zneR","top":"styles_top__2nQpn"};